<ion-app class="layout-public">
  <ion-content>
    <ion-router-outlet></ion-router-outlet>
  </ion-content>
  <ion-footer align="middle"> Copyright &copy; {{year}} Etherealmed (Pty) Ltd. </ion-footer>
</ion-app>